import React from "react";
import {Table, Tag} from "antd";
import {getDownloadLinkFiles} from "../../api/api";


function ReportHistoryTable({data, isLoading, pagination, style, onChange}) {
    const download = (key) => {
        getDownloadLinkFiles(key).then(response => {
            const a = document.createElement('a');
            a.href = response.link;
            a.download = response.name;
            a.click();
        })
    }
    const sendReportEmail = (id, key, customerReference, endDate) => {
        // exportReportEmail(key, customerReference, endDate).then(response => {
        //     updateReportEmailTime(id).then(response => {
        //         displaySuccessMessage("Sent email to the recipe is success")
        //         this.props.reloadData()
        //     });
        // }).catch(error => {
        //     displayGenericError(error);
        // });
    }

    const columns = [
        {title: "ID", width: 100, dataIndex: "id", key: "id"},
        {
            title: "Date",
            dataIndex: "date",
            align:"center",
            key: "date"
        },
        {
            title: "Report Name",
            dataIndex: "name",
            align:"center",
            key: "name"
        },
        {
            title: "Conditions",
            dataIndex: "reportRequestFilter",
            align:"center",
            key: "reportRequestFilter",
            render: (text, record) => {
                let filter = "";
                if (text) {
                    if (text.reportType != null) {
                        filter += "Report Type = " + text.reportType + "; ";
                    }
                    if (text.customerIds != null) {
                        filter += "Report id = " + text.customerIds + "; ";
                    }
                    if (text.startDate != null) {
                        filter += "Start Date = " + text.startDate + "; ";
                    }
                    if (text.endDate != null) {
                        filter += "End Date = " + text.endDate + "; ";
                    }
                    if (text.sourceCurrency != null) {
                        filter += "Currency = " + text.sourceCurrency + "; ";
                    }
                }
                return filter;
            }
        },
        {
            title: "Download",
            dataIndex: "s3Link",
            align:"center",
            key: "s3Link",
            render: (text, record) => {
                if (text) {
                    return <a onClick={() => download(text)}> download {record.name}</a>
                } else {
                    return ''
                }

            }
        },
       /* {
            title: "Report Email",
            dataIndex: "reportEmailTime",
            key: "reportEmailTime",
            render: (text, record) => {
                let reportEmailTime = "";
                if (record.name === 'Customer') {
                    if (record.reportEmailTime != null && record.reportEmailTime !== '') {
                        reportEmailTime += record.reportEmailTime;
                    } else {
                        reportEmailTime = <a onClick={() => this.sendReportEmail(record.id, record.s3Link,
                            record.reportRequestFilter.customerIds, record.reportRequestFilter.endDate)}> Sent Report
                            Email</a>
                    }
                }
                return reportEmailTime;
            }
        },*/
        {
            title: "Status",
            dataIndex: "status",
            align:"center",
            key: "status",
            render: (text, record) => {
                let color = "green"
                if (text === "COMPLETED") {
                    color = "#87d068";
                } else if (text === "PROGRESS" || text === "PROCESSING") {
                    color = "orange";
                } else if (text === "FAILED") {
                    color = "#E55050";
                }
                return <Tag color={color}>{text}</Tag>;
            }
        },
        {
            title: "Failed reason",
            dataIndex: "failedReason",
            key: "failedReason",

        },
    ];
    return (

        <Table
            className="orders-table management-table"
            columns={columns}
            dataSource={data}
            loading={isLoading}
            pagination={pagination}
            onChange={onChange}
            style={{...style}}
            rowKey="id"
        />
    );
}

export default ReportHistoryTable;